@if (chart(); as c) {
  <svg class="sz-scatter-trend" [attr.viewBox]="viewBox" xmlns="http://www.w3.org/2000/svg">
    <g class="sz-scatter-trend__y-labels">
      @for (label of c.yLabels; track label.y) {
        <text [attr.x]="0" [attr.y]="label.y + 4">{{ label.text }}</text>
      }
    </g>
    <g class="sz-scatter-trend__grid">
      @for (label of c.yLabels; track label.y) {
        <line [attr.x1]="padL" [attr.y1]="label.y" [attr.x2]="viewW" [attr.y2]="label.y" />
      }
    </g>
    <line
      class="sz-scatter-trend__best-line"
      [attr.x1]="padL"
      [attr.y1]="c.bestLineY"
      [attr.x2]="viewW"
      [attr.y2]="c.bestLineY" />
    <text class="sz-scatter-trend__best-tag" [attr.x]="viewW - 4" [attr.y]="c.bestLineY - 4">BEST</text>
    <line
      class="sz-scatter-trend__trend"
      [attr.x1]="c.trendX1"
      [attr.y1]="c.trendY1"
      [attr.x2]="c.trendX2"
      [attr.y2]="c.trendY2" />
    <g class="sz-scatter-trend__dots">
      @for (dot of c.dots; track $index) {
        @if (dot.isPb) {
          <circle [attr.cx]="dot.cx" [attr.cy]="dot.cy" [attr.r]="5" class="sz-scatter-trend__pb-ring" />
        }
        <circle
          [attr.cx]="dot.cx"
          [attr.cy]="dot.cy"
          [attr.r]="dot.isPb ? 3 : 2.5"
          [attr.opacity]="dot.opacity"
          [class.is-pb]="dot.isPb"
          class="sz-scatter-trend__dot" />
      }
    </g>
    <g class="sz-scatter-trend__x-labels">
      <text [attr.x]="padL + 8" [attr.y]="viewH - 8" text-anchor="start">{{ leftLabel() }}</text>
      <text [attr.x]="viewW - 8" [attr.y]="viewH - 8" text-anchor="end">{{ rightLabel() }}</text>
    </g>
  </svg>
}
